import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2Icon } from 'lucide-react';
const deliverables = ['El Protocolo de Rescate de 15 Minutos paso a paso.', "Mapa visual de los 3 puntos de presión de 'emergencia'.", "Guía de configuración del 'Kit de Supervivencia' para tu auto o escritorio.", 'Lista de suplementos preventivos (Magnesio/Riboflavina) con dosis recomendadas.', 'Scripts rápidos para explicar tu condición a jefes o clientes sin sonar como una excusa.'];
export function WhatYouGet() {
  return <section className="py-20 px-6 bg-navy-800" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <FadeIn data-id="element-183">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-184">
            Lo Que Obtienes Hoy
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-185">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-186">
              <div className="flex items-center p-5 bg-navy-900 rounded-xl border border-slate-700/50 hover:border-teal-500/30 transition-colors" data-id="element-187">
                <CheckCircle2Icon className="w-6 h-6 text-teal-400 mr-4 flex-shrink-0" data-id="element-188" />
                <p className="text-slate-200 font-medium" data-id="element-189">{item}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}